interface AppleContactsIconProps {
  className?: string;
  size?: number;
}

export const AppleContactsIcon = ({
  className,
  size = 32,
}: AppleContactsIconProps) => {
  return (
    <div>
      <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0" y="0" width="100" height="100" rx="20" fill="#F6D37C" />
        <rect x="10" y="0" width="14" height="100" fill="#C89C47" />
        <rect x="24" y="0" width="2" height="100" fill="#B88935" />
        <circle cx="60" cy="39" r="14" fill="#7A5523" />
        <path d="M33 80c2.9-13.2 13.3-22 27-22s24.1 8.8 27 22" fill="#7A5523" />
        <rect x="5" y="17" width="8" height="16" rx="4" fill="#E5E5EA" />
        <rect x="5" y="42" width="8" height="16" rx="4" fill="#E5E5EA" />
        <rect x="5" y="67" width="8" height="16" rx="4" fill="#E5E5EA" />
      </svg>
    </div>
  );
};
